import { notification } from 'antd';
import { logout } from '@redux/auth/actions';
import { store } from '@redux/store';
import { ConfigApiWrapperType } from '@redux/crudCreator/types';
import I18n from 'i18next';

const ERROR_CODE = [];

export async function apiWrapper(
  config: ConfigApiWrapperType = {
    isShowProgress: true,
    isShowSuccessNoti: false,
  },
  apiFunc,
  ...params
) {
  try {
    const response = await apiFunc(...params);
    config?.isShowSuccessNoti &&
      notification.success({
        message: I18n.t('common.success.title'),
        description:
          response.message ||
          config.successDescription ||
          I18n.t('common.success.description'),
      });
    return response;
  } catch (err) {
    notification.destroy();
    notification.error({
      message: I18n.t('common.error.title'),
      description: JSON.stringify(err?.message) || 'error.description',
    });
    checkError(err);
    throw err;
  }
}

export function checkError(res) {
  if (res.code === 401) {
    localStorage.getItem('devtify-token') && store.dispatch(logout());
  }
  if (ERROR_CODE.indexOf(res.code) > -1) {
    window.location.href = `/error/${res.code}`;
  }
}
